<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="132"
    height="132"
    viewBox="0 0 132 132"
    fill="none"
  >
    <path
      d="M27.75 110V55H93.75V60.5C97.6 60.5 101.285 61.05 104.75 62.095V55C104.75 48.95 99.8 44 93.75 44H88.25V33C88.25 17.82 75.93 5.5 60.75 5.5C45.57 5.5 33.25 17.82 33.25 33V44H27.75C21.7 44 16.75 48.95 16.75 55V110C16.75 116.05 21.7 121 27.75 121H62.18C59.87 117.7 58.055 113.96 56.845 110H27.75ZM44.25 33C44.25 23.87 51.62 16.5 60.75 16.5C69.88 16.5 77.25 23.87 77.25 33V44H44.25V33Z"
      fill="#A6A6A6"
    />
    <path
      d="M93.75 71.5C78.57 71.5 66.25 83.82 66.25 99C66.25 114.18 78.57 126.5 93.75 126.5C108.93 126.5 121.25 114.18 121.25 99C121.25 83.82 108.93 71.5 93.75 71.5ZM93.75 82.5C98.315 82.5 102 86.185 102 90.75C102 95.315 98.315 99 93.75 99C89.185 99 85.5 95.315 85.5 90.75C85.5 86.185 89.185 82.5 93.75 82.5ZM93.75 115.5C88.085 115.5 83.08 112.64 80.11 108.24C84.125 105.93 88.745 104.5 93.75 104.5C98.755 104.5 103.375 105.93 107.39 108.24C104.42 112.64 99.415 115.5 93.75 115.5Z"
      fill="#A6A6A6"
    />
  </svg>
</template>
